import { createContext, useEffect, useReducer } from "react";
import axios from "axios";

const INITIAL_STATE = {
  admin: null, // ❗ plus de localStorage comme source de vérité
  loading: true, // 🔥 important pour éviter le flicker
  error: null,
};

export const AuthAdminContext = createContext(INITIAL_STATE);

const AuthAdminReducer = (state, action) => {
  switch (action.type) {

    case "ADMIN_LOGIN_START":
      return {
        admin: null,
        loading: true,
        error: null,
      };

    case "ADMIN_LOGIN_SUCCESS":
      return {
        admin: action.payload,
        loading: false,
        error: null,
      };

    case "ADMIN_LOGIN_ERROR":
      return {
        admin: null,
        loading: false,
        error: action.payload,
      };

    case "ADMIN_LOGOUT":
      return {
        admin: null,
        loading: false,
        error: null,
      };

    default:
      return state;
  }
};

export const AuthAdminContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(AuthAdminReducer, INITIAL_STATE);
  console.log("STATE:", state);

  // 🔥 CHECK SESSION AU LANCEMENT
  useEffect(() => {
    const checkAdmin = async () => {
      try {
        const res = await axios.get(
          "https://api.komorotel.com/api/authAdmin/me",
          {
            withCredentials: true, // 🔐 indispensable pour cookie
          }
        );

        dispatch({
          type: "ADMIN_LOGIN_SUCCESS",
          payload: res.data,
        });

      } catch (err) {
        dispatch({ type: "ADMIN_LOGOUT" });
      }
    };

    checkAdmin();
  }, []);

  return (
    <AuthAdminContext.Provider
      value={{
        admin: state.admin,
        loading: state.loading,
        error: state.error,
        dispatch,
      }}
    >
      {/* 🔥 éviter flicker */}
      {!state.loading && children}
    </AuthAdminContext.Provider>
  );
};